import { useTranslation } from 'hooks/useTranslation'
import { BannerText } from 'components/BannerText'
import { BannerHeader } from 'features/RawFoodSubscription/RawFoodSubscription.styles'
import { styled } from 'stitches.config'

const ShippingContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  maxWidth: '344px',
  flexDirection: 'column',

  '@bp2': {
    maxWidth: '1070px',
  }
})


export const Shipping = () => {
  const { t } = useTranslation()


  return (
    <BannerText background="primary-700">
      <ShippingContainer>
        <BannerHeader>{t('raw-food-subscription:shipping.title')}</BannerHeader>
        <BannerHeader>{t('raw-food-subscription:shipping.subtitle')}</BannerHeader>
      </ShippingContainer>
    </BannerText>
  )
}
